module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "VerseLogo.e24b56c2.png";